import { render } from "./Changelog.vue?vue&type=template&id=59a4ea60&scoped=true"
import script from "./Changelog.vue?vue&type=script&lang=js"
export * from "./Changelog.vue?vue&type=script&lang=js"

import "./Changelog.vue?vue&type=style&index=0&id=59a4ea60&scoped=true&lange=scss&lang=css"

import exportComponent from "C:\\AgentPools\\FAOAgentPool\\_work\\32\\s\\WEPTW_Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59a4ea60"]])

export default __exports__